import AppRecord from './AppRecord.js'
import APP from 'src/main.js'

class EntityInvoiceType extends AppRecord {
  get controller_name(){
    return 'EntityInvoiceTypesController'
  }
  get invoice_type(){
    return this.constructor.employeeStore.invoice_types.find(it => it.id === this.invoice_type_id)||{}
  }

  get invoice_type_interval(){
    let ret = this.constructor.employeeStore.invoice_type_intervals.find((e) => e.id == this.invoice_type_interval_id)
    return (ret || {})
  }

  get invoice_type_intervals(){
    let ret = this.constructor.employeeStore.invoice_type_intervals.filter((e) => e.invoice_type_id == this.invoice_type_id)
    return ret
  }

  get hoverText(){
    let text = ''
    if (this.invoice_type_interval && this.invoice_type_interval.invoice_type_interval_lines){
      this.invoice_type_interval.invoice_type_interval_lines.forEach(itil => {        
        if (text.length > 0){
          text += "%\n"
        }
        text += "Type: " + itil.fee_type + " Rate: " + itil.formatted_rate
      });
    }

    return text
  }
}

export default EntityInvoiceType
